import { useContext, useEffect, useState } from 'react';
import useSmartState from '../../../../common/hooks/useSmartState';
import FormBuilder from '../../../../library/Builders/FormBuilder';
import { SmartContext } from '../../../../library/Core/SmartContext';
import { getFuzzySearchCriteria } from '../../../../library/Core/SmartFunctions';
import { FormSection } from '../../../../library/Core/SmartTypes';
import FiltersApplied from '../../../../library/SimpleControls/FiltersApplied';
import InternalAdminQRReportService from './InternalAdminQRReportService';

export const SearchCriteria = () => {
    const { state, dispatch } = useContext(SmartContext);
    const { setStateValue } = useSmartState();
    const searchFormConfig = state.formConfig?.sectionRepository[0] as FormSection;
    const [isExpanded, setIsExpanded] = useState(true);
    const [fuzzySearchText, setFuzzySearchText] = useState('');
    const [isInitialLoad, setIsInitialLoad] = useState(true);  // Flag for initial load

  
    useEffect(() => {
        if (isInitialLoad) {
            fetchAlumniCount(state);
            setIsInitialLoad(false);
            return; 
        }

        InternalAdminQRReportService.search(state.data.searchCriteria, state.routeInfo.pageName).then((response: any) => {
                setStateValue('alumniList', response.data);
                fetchAlumniCount(state);
            });
    }, [state.data.searchCriteria]);

    const handleFuzzySearch = (event: any) => {
        event.preventDefault();
        // if (isEmpty(fuzzySearchText)) return;

        const currentSearchCriteria = state.data.searchCriteria;

        const mergedSearchCriteria = {
            ...currentSearchCriteria,
            ...getFuzzySearchCriteria(fuzzySearchText) 
        };
        setStateValue('searchCriteria',mergedSearchCriteria);
    };

    const handleClearAll = () => {
        const defaultCriteria = InternalAdminQRReportService.getDefaultSearchCriteria(state.routeInfo.pageName);
        setStateValue('searchCriteria', defaultCriteria);
    };

    const fetchAlumniCount = async (state:any) => {
        try {
            const alumniCountData = await InternalAdminQRReportService.searchCount(state.data.searchCriteria, state.routeInfo.pageName);
            await new Promise(resolve => setTimeout(resolve, 200));
            dispatch({
                type: 'SET_INTERNAL_STATE',
                payload: { key:"alumniCount", value:alumniCountData?.data },
            });
        } catch (error) {
            console.error("Error fetching alumni count:", error);
        }
    }

    return (
        <>
            <div className="d-flex flex-wrap justify-content-between align-items-start align-items-md-center mb-2 filterSearch">
                <div className="d-flex flex-wrap flex-1 mb-0 justify-content-start">
                    <button className="btn-grpfiter me-3" onClick={() => setIsExpanded(!isExpanded)}>
                        <i className="icon-filter font-13 me-2"></i>
                        Filters
                    </button>
                    {state?.routeInfo?.pageName != 'internal-admin-all-school-statistics' && (
                    <div className="search alumniSearch m-0 open position-static flex-1 mb-2">
                        <form className="form-inline d-flex flex-wrap justify-content-between d-block" onSubmit={handleFuzzySearch}>
                            <input
                                value={fuzzySearchText}
                                placeholder="Search by Alumni Name, Email"
                                aria-label="Search"
                                className="form-control flex-1 font-13 font-500 text-truncate"
                                onChange={(event) => setFuzzySearchText(event?.target.value)}
                            />
                            <button className="btn btn-search icon icon-search"></button>
                        </form>
                        {/* <a href="" className="btn-search-toggle icon-search"></a> */}
                    </div>
                    )}
                    {isExpanded && (
                        <div className="col-12 fitergroup p-3 bg-body-secondary">
                            <FormBuilder key="searchCriteria" section={searchFormConfig} dataKey="searchCriteria" />
                        </div>
                    )}
                </div>
            </div>

            <div className="filterresult">
                <FiltersApplied dataKey="searchCriteria" onClearAll={handleClearAll} />
            </div>
        </>
    );
};
